require('./RARoboStrategyItem.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

// @utilites
const { FormattedText } = require('core/i18n').i18n;

class RAStrategyItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { disabled, id } = this.props;
        if (!disabled) {
            this.props.selectStrategy(id);
        }
    }

    buildDetailsButton() {
        return (
            <section className="ra-robo-strategy-item__link-button">
                <OKButton
                    modifier="link-emphasize"
                    inverse={false}
                    onClick={this.props.onStrategyDetailsClick}
                >
                    <FormattedText value="raStrategyItem-seeDetails" />
                </OKButton>
            </section>
        );
    }

    buildNotAvailableText() {
        return (
            <section className="ra-robo-strategy-item__link-button">
                <p className="ra-robo-strategy-item__not-available-text">
                    <FormattedText value="raStrategyItem-strategyNotAvailable" />
                </p>
            </section>
        );
    }

    render() {
        const {
            countryImage,
            countryLabel,
            disabled,
            id,
            modifyPlan,
            profileType,
            riskType,
            selectedCard,
        } = this.props;

        const currentClassname = classnames('ra-robo-strategy-item', {
            'ra-robo-strategy-item--is-disabled': disabled,
        });

        const containerClassname = classnames(
            `ra-robo-strategy-item__container`,
            {
                [`ra-robo-strategy-item__building-${id}__selected`]:
                    selectedCard === id,
                [`ra-robo-strategy-item__building-${id}__available`]:
                    selectedCard !== id,
                [`ra-robo-strategy-item__building-${id}__available__active`]:
                    selectedCard !== id && !disabled,
            },
        );

        const innerContainerClassname = classnames(
            `ra-robo-strategy-item__container__inner`,
        );

        const innerTextsClassname = classnames(
            `ra-robo-strategy-item__container__inner-texts`,
        );

        const countrySelectedClassname = classnames(
            `ra-robo-strategy-item__building-${id}__available__country`,
        );

        const imgSelectedClassname = classnames(
            `ra-robo-strategy-item__building-${id}__available__img`,
        );

        const riskTypeTextClassname = classnames(
            `ra-robo-strategy-item__building-${id}__available__risk`,
        );

        const profileTypeTextClassname = classnames(
            `ra-robo-strategy-item__building-${id}__available__profile`,
        );

        const seeDetails =
            !modifyPlan && selectedCard === id
                ? this.buildDetailsButton()
                : null;

        return (
            <div className={currentClassname}>
                <div className={containerClassname} onClick={this.handleClick}>
                    <p className={profileTypeTextClassname}>{profileType}</p>
                    <div className={innerContainerClassname}>
                        <img
                            className={imgSelectedClassname}
                            src={countryImage}
                        ></img>
                        <div className={innerTextsClassname}>
                            <p className={countrySelectedClassname}>
                                {countryLabel}
                            </p>
                            <p className={riskTypeTextClassname}>{riskType}</p>
                        </div>
                    </div>
                </div>
                {seeDetails}
                {disabled && this.buildNotAvailableText()}
            </div>
        );
    }
}

RAStrategyItem.propTypes = {
    countryImage: PropTypes.string.isRequired,
    countryLabel: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    id: PropTypes.number.isRequired,
    modifyPlan: PropTypes.bool.isRequired,
    onStrategyDetailsClick: PropTypes.func,
    profileType: PropTypes.string.isRequired,
    riskType: PropTypes.string.isRequired,
    selectedCard: PropTypes.number.isRequired,
    selectStrategy: PropTypes.func.isRequired,
};

RAStrategyItem.defaultProps = {
    disabled: false,
};

module.exports = RAStrategyItem;
